
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AuthService } from '@framework/services';

@Injectable()
export class ClientHttpInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {

    }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.authService.cognito.getIdToken()).pipe(
            switchMap(token => {
                if (request.url === '/api/v3/companies/' && request.method === 'POST' && token) {
                    const headers = request.headers
                        .set('Authorization', 'Bearer ' + token)
                        .append('Content-Type', 'application/json').append('Accept', 'application/json,text/plain');
                    const requestClone = request.clone({
                        headers
                    });
                    return next.handle(requestClone);
                }
                // Gallery admin APIs authenticate via Cognito Bearer (same as other company-admin routes).
                if (token && request.url.startsWith('/api/v3/photo-galleries')) {
                    return next.handle(request.clone({
                        headers: request.headers.set('Authorization', 'Bearer ' + token)
                    }));
                }
                return next.handle(request);
            })
        );
    }
}
